import type { Member, MemberPublic } from '@/lib/db/types';
import { PlayerSlotPicker } from '@/components/shared/PlayerSlotPicker';

export interface NonMemberPlayer {
  name: string;
  handicap?: string;
}

interface Props {
  organizer: Member;
  members: MemberPublic[];
  following: string[];
  selectedIds: string[];
  onToggle: (id: string, adding: boolean) => void;
  newPlayers: NonMemberPlayer[];
  onNewPlayersChange: (players: NonMemberPlayer[]) => void;
  atCap: boolean;
  onCapHit: () => void;
  onFollowingChange?: (ids: string[]) => void;
  organizerPlaying?: boolean;
  onOrganizerPlayingChange?: (playing: boolean) => void;
  /** Show handicap field on guest rows (group rounds). */
  showGuestHandicap?: boolean;
}

export function GameSetupMemberSelect({
  organizer,
  members,
  following,
  selectedIds,
  onToggle,
  newPlayers,
  onNewPlayersChange,
  atCap,
  onCapHit,
  organizerPlaying = true,
  onOrganizerPlayingChange,
  showGuestHandicap = false,
}: Props) {
  return (
    <div className="space-y-3">
      {onOrganizerPlayingChange && (
        <div className="flex items-center justify-between rounded-[10px] border border-line bg-paper px-3 py-2.5">
          <div>
            <div className="text-[13px] font-semibold text-ink">I&apos;m playing</div>
            <div className="text-[11px] text-mute">Turn off to organize without joining the foursome</div>
          </div>
          <button
            type="button"
            onClick={() => onOrganizerPlayingChange(!organizerPlaying)}
            className={`relative h-6 w-[42px] shrink-0 rounded-full transition-colors ${organizerPlaying ? 'bg-gold' : 'bg-line'}`}
          >
            <div className={`absolute top-0.5 h-5 w-5 rounded-full bg-paper transition-all ${organizerPlaying ? 'left-5' : 'left-0.5'}`} />
          </button>
        </div>
      )}

      <PlayerSlotPicker
        organizer={organizer}
        members={members}
        following={following}
        selectedMemberIds={selectedIds}
        guests={newPlayers}
        organizerPlaying={organizerPlaying}
        showGuestHandicap={showGuestHandicap}
        atCap={atCap}
        onCapHit={onCapHit}
        onSelectMember={(id) => onToggle(id, true)}
        onRemoveMember={(id) => onToggle(id, false)}
        onAddGuest={(guest) => onNewPlayersChange([...newPlayers, guest])}
        onUpdateGuest={(index, guest) => {
          onNewPlayersChange(newPlayers.map((p, i) => (i === index ? guest : p)));
        }}
        onRemoveGuest={(index) => {
          onNewPlayersChange(newPlayers.filter((_, i) => i !== index));
        }}
      />
    </div>
  );
}
